import { FaqCollection } from '../../../graphql.generated';
import ExpandedFaqCollection from './ExpandedFaqCollection';

/* This helper function normalises the types coming from GQL
 * and ensures the correct values are set
 */
export default function expandedFaqs(faqData: FaqCollection) {
    const { title, description, faqs } = faqData;

    const newFaqs = faqs.map((faq) => {
        const author = faq.author
            ? {
                  author: {
                      authorName: faq.author.authorName,
                      authorSlug: faq.author.authorSlug,
                      authorImage: { url: faq.author.authorImage.url },
                      ...(faq.author.jobTitle && {
                          jobTitle: faq.author.jobTitle,
                      }),
                  },
              }
            : null;
        return {
            question: faq.question,
            answer: faq.answer,
            ...author,
        };
    });

    return (
        <ExpandedFaqCollection
            title={title}
            description={description ?? ''}
            faqs={newFaqs}
        />
    );
}
